// import "./SawinSelect.scss";
//@ts-ignore
import "./CustomDropdown.scss";
import { getFlagUrl, getFlagUrlByName } from "../../utility/flagUrl";
import React, { useState, Fragment, useEffect } from "react";
// import useClickOutside from "../../hooks/useClickOutside";

import { ChevronDown } from "react-bootstrap-icons";
import useClickOutside from "../../hooks/useClickOutside";
// import HelperService from "../../utility/HelperService";

interface PropData {
  placeholder?: string;
  options: Options[];
  selected: any;
  isSearchable?: boolean;
  onChange: any;
  type?: string;
  sakey?: string;
  disValue?: string;
  disCode?: string;
  value?: string;
  isHideArrow?: boolean;
  isDisable?: boolean;
  isLoading?: boolean; // show a field-level spinner while the options/value are still loading
  forceClose?: boolean;
  isCustomInput?: boolean;
  max?: number;
  column?: number;
  className?:any;
}

export interface Options {
  id: any;
  code?: string;
  value: string;
  value2?: string;
  parentCode?: string;
  object?: any;
  icon?: string;
  flag?: string; // ISO 3166-1 alpha-2 code (e.g. "IN") -> flag-icons country flag
  pill?: string; // small badge shown after the option label (e.g. a relation)
}

// Flag url for a country option: prefer the ISO `flag` code, else resolve by
// name (country_code is only populated for some rows, name is always present).
// Only options explicitly marked as country options (carry a `flag` key) get a
// flag, so unrelated dropdowns whose value happens to be a country name don't.
const optionFlagUrl = (o?: Options): string =>
  o && "flag" in o ? getFlagUrl(o.flag || "") || getFlagUrlByName(o.value) : "";

const CustomDropdown = (props: PropData) => {
  let textInput = React.createRef<HTMLInputElement>();
  const [placeholder, setPlaceholder] = useState(props.placeholder);
  const [options, setOptions] = useState(props.options);
  const [selectedOption, setSelectedOption] = useState(props.selected);
  const [isFocus, setIsFocus] = useState(false);
  const [search, setSearch] = useState("");
  const [isOpenTop, setIsOpenTop] = useState(false);
  // When the dropdown is inside a scrollable container (e.g. a modal body
  // `.fpm-body`), the open menu is capped to the space available there so it
  // never overflows / gets clipped by it — it scrolls internally instead.
  const [menuMaxH, setMenuMaxH] = useState<number | null>(null);
  let index = -1;
  let selectedValue = "";
  const [userInput, setUserInput] = useState(
    props.isSearchable ? "" : props.placeholder
  );

  useEffect(() => {
    setSelectedOption(props.selected);
  }, [props.selected])

  useEffect(() => {
    setOptions(props?.options || []);
    const selected = props.selected;
    if (selected != selectedOption) {
      setSelectedOption(selected);
    }

    let foundIndex = -1;
    let foundValue = "";

    props?.options?.forEach((value, i: number) => {
      if (value.id == selected) {
        foundIndex = i;
        foundValue = value.value;
      }
    });

    if (foundIndex !== -1) {
      setUserInput(foundValue);
      setSelectedIndex(foundIndex);
    } else if (selected === "resetsawin" || selected === "" || selected == null) {
      setSearch("");
      setUserInput(props.isSearchable ? "" : props.placeholder);
      setSelectedIndex(-1);
      setSelectedOption(selected);
    }

    if (props.isCustomInput && !userInput) {
      setUserInput(selected);
    }

    if (props.placeholder == "SawinSelect") {
      alert(selected + "  " + foundValue + " " + props.options.length);
    }
  }, [props.selected, props.options]);

  useEffect(() => {
    if (props.forceClose) {
      setIsFocus(false);
    }
  }, [props.forceClose]);

  const [selectedIndex, setSelectedIndex] = useState(index);

  let domNode = useClickOutside(() => {
    setIsFocus(false);
    if (props.isSearchable && search) {
      if (props.isCustomInput) {
        setUserInput(search);
        setSelectedOption(search);
        props.onChange(search);
      }
    }
  }, this);

  const getScrollParent = (element: any) => {
    let parent = element?.parentElement;

    while (parent) {
      const style = window.getComputedStyle(parent);
      const overflowY = style.overflowY;

      if ((overflowY === "auto" || overflowY === "scroll") && parent.scrollHeight > parent.clientHeight) {
        return parent;
      }

      parent = parent.parentElement;
    }

    return null;
  };

  const checkPossition = () => {
    const dropdownNode = domNode.current;

    if (!dropdownNode) {
      return;
    }

    const rect = dropdownNode.getBoundingClientRect();
    const scrollParent = getScrollParent(dropdownNode);
    const topBoundary = scrollParent ? scrollParent.getBoundingClientRect().top : 0;
    const bottomBoundary = scrollParent ? scrollParent.getBoundingClientRect().bottom : window.innerHeight;
    const topHeight = rect.top - topBoundary;
    const bottomHeight = bottomBoundary - rect.bottom;

    // Inside a scrollable container (modal body, etc.): open towards whichever side has MORE room
    // and cap the menu to that room, so the menu always stays fully within the container instead
    // of spilling past its edge and being clipped (user 17-Oct-2026). No cap in plain page context
    // (relies on the viewport / the menu's own CSS max-height, unchanged behaviour).
    if (scrollParent) {
      const openTop = topHeight > bottomHeight;
      setIsOpenTop(openTop);
      const avail = Math.round((openTop ? topHeight : bottomHeight) - 12);
      setMenuMaxH(Math.max(120, avail));
    } else {
      const openTop = !(bottomHeight > 300 || topHeight <= 280);
      setIsOpenTop(openTop);
      setMenuMaxH(null);
    }
  };

  const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const highlight = (text: any) => {
    const q = (search || "").trim();
    if (!q || typeof text !== "string") return text;
    const parts = text.split(new RegExp(`(${escapeRegExp(q)})`, "ig"));
    return parts.map((part, i) =>
      part.toLowerCase() === q.toLowerCase() ? (
        <mark className="dd-highlight" key={i}>
          {part}
        </mark>
      ) : (
        <Fragment key={i}>{part}</Fragment>
      )
    );
  };

  let optionsListComponent;
  // an option whose label is null/undefined (e.g. a folio or platform with no name yet)
  // must not crash the filter - it is matched as an empty string
  let searchOption: Options[] = search
    ? options.filter(function (option: any) {
      return String(option?.value ?? "").toLowerCase().includes(search.toLowerCase());
    })
    : options;

  if (searchOption.length) {
    optionsListComponent = (
      <ul className={"options " + (isOpenTop ? "open-top " : "") + (menuMaxH ? "dd-capped" : "")}
        style={menuMaxH ? { maxHeight: menuMaxH, overflowY: "auto" } : undefined}>
        {searchOption.map((suggestion: Options, index) => {
          let className;
          if (index === selectedIndex) {
            className = "option-active";
          }

          return (
            <li
              className={className}
              key={index}
              onMouseDown={() => onSelect(suggestion)}
            >
              {optionFlagUrl(suggestion) ? (
                <div className="row-icon-view">
                  <img src={optionFlagUrl(suggestion)} className="dd-flag" alt="" />
                  <div className="option">{highlight(suggestion.value)}</div>
                </div>
              ) : suggestion.icon ? (
                <div className="row-icon-view">
                  <img
                    src={suggestion.icon}
                    className="row-icons"
                    onError={(e) => {
                      (e.currentTarget as HTMLImageElement).style.display = "none";
                    }}
                  />
                  <div className="option">{highlight(suggestion.value)}</div>
                </div>
              ) : suggestion.code ? (
                props.column == 3 ? (
                  <div className="row option">
                    <div className="col-md-2 code-div">{suggestion.code}</div>
                    <div className="col-md-5">{highlight(suggestion.value)}</div>
                    <div className="col-md-5">{highlight(suggestion.value2)}</div>
                  </div>
                ) : (
                  <div className="row option">
                    <div className="col-md-5 code-div"> {suggestion.code}</div>
                    <div className="col-md-7">{highlight(suggestion.value)}</div>
                  </div>
                )
              ) : suggestion.pill ? (
                <div className="option dd-pill-row">
                  <span className="dd-pill-name">{highlight(suggestion.value)}</span>
                  <span className="dd-pill">{suggestion.pill}</span>
                </div>
              ) : (
                <div className="option">{highlight(suggestion.value)}</div>
              )}
            </li>
          );
        })}
      </ul>
    );
  } else {
    optionsListComponent = (
      <div className="no-options">
        {props.isLoading ? (
          <span className="dd-loading"><span className="dd-spin-ic" /> Loading…</span>
        ) : (
          <em>No data found</em>
        )}
      </div>
    );
  }

  const onSelect = (e: Options) => {
    setSearch("");
    setIsFocus(false);
    setUserInput(e.value);
    setSelectedOption(e.id);
    options.map((value, i: number) => {
      if (value.id === e.id) {
        index = i;
        selectedValue = value.value;
        if (props.onChange) {
          props.onChange(e);
        }
        setSelectedIndex(index);
      }
    });
  };

  const handleKey = (e: any) => {
    if (e.keyCode === 40) {
      if (selectedIndex < options.length - 1)
        setSelectedIndex(selectedIndex + 1);
    } else if (e.keyCode === 38) {
      if (selectedIndex > 0) setSelectedIndex(selectedIndex - 1);
    } else if (e.keyCode === 13) {
      options.map((value: Options, i: number) => {
        if (selectedIndex === i) {
          onSelect(value);
        }
      });
    }
  };

  const checkOption = (enterValue: any) => {
      var isFound = false;
      // If the input already reflects the currently selected option, don't re-resolve — avoids
      // duplicate-label collisions overwriting a just-made selection on blur.
      if (selectedOption != null && enterValue === userInput && selectedIndex !== -1) {
        setSearch("");
        return;
      }

      options.map((value: Options, i: number) => {
        if (value.id === enterValue) {   // id-only match, no more `|| value.value === enterValue`
          setUserInput(enterValue);
          setSelectedOption(enterValue);
          onSelect(value);
          props.onChange(value);
          isFound = true;
        }
      });

      if (props.isCustomInput && enterValue && !isFound) {
        setUserInput(enterValue);
        setSelectedOption(enterValue);
        var temp: Options = { id: enterValue, value: enterValue };
        onSelect(temp);
        props.onChange(temp);
      }

      setSearch("");
  };

  // flag of the currently-selected option, to show on the collapsed field
  const selectedFlagUrl = optionFlagUrl(
    (props.options || []).find((o: Options) => o.id == selectedOption)
  );
  // pill (e.g. relation) of the currently-selected option, shown on the collapsed field
  const selectedOptionData = (props.options || []).find((o: Options) => o.id == selectedOption);
  const selectedPill = selectedOptionData && selectedOptionData.pill ? selectedOptionData.pill : "";

  return (
    <>
      <Fragment>
        <div
          ref={domNode}
          id={props.sakey ? props.sakey : "selectId"}
          key={props.sakey}
          className={
            props.isDisable === true ? "disabled-select select" : "select w-100"
          }
        >
          {props.isLoading && <span className="dd-field-spinner" aria-label="Loading" role="status" />}
          {props.isSearchable ? (
            <div
              className={"form-style " + (isFocus ? "zindex" : "")}
              tabIndex={0}
            >
              {selectedFlagUrl && (
                <img src={selectedFlagUrl} className="dd-flag dd-flag-sel" alt="" />
              )}
              <input
                ref={textInput}
                className={"form-control text-truncate dropdown" + (selectedFlagUrl ? " has-flag" : "") + (selectedPill && !isFocus ? " has-pill" : "")}
                value={isFocus ? search : userInput}
                type="text"
                // onKeyPress={(e) =>
                //   props.max ? HelperService.maxNumber(e, props.max) : ""
                // }
                onBlur={(e) => checkOption(e.target.value)}
                onKeyDown={(e) => {
                  handleKey(e);
                }}
                onClick={() => {
                  setIsFocus(!isFocus);
                }}
                onMouseDown={() => {
                  if (!props.isDisable) {
                    if (!isFocus) {
                      checkPossition();
                    }
                    // setIsFocus(true);
                  }
                }}
                disabled={props.isDisable}
                placeholder={placeholder}
                onChange={(e) => setSearch(e.target.value)}
              />
              {/* {!props.isHideArrow && !isFocus ? (
                <div className="col-12 d-flex justify-content-end">
                  <ChevronDown
                    id="img_downarrow"
                    className="searchdownarrow text-dark"
                  />
                </div>
              ) : (
                ""
              )} */}
              {selectedPill && !isFocus && (
                <span className="dd-sel-pill">{selectedPill}</span>
              )}
              {isFocus && props.isDisable == false ? optionsListComponent : ""}
            </div>
          ) : (
            <div
              className={"form-style " + (isFocus ? "zindex" : "")}
              onKeyDown={(e) => {
                handleKey(e);
              }}
              onClick={() => {
                setIsFocus(!isFocus);
              }}
              tabIndex={0}
              onMouseDown={() => {
                if (!props.isDisable) {
                  if (!isFocus) {
                    checkPossition();
                  }
                }
              }}
            >
              <div className="form-control select-div text-truncate">
                {selectedFlagUrl && (
                  <img src={selectedFlagUrl} className="dd-flag dd-flag-inline" alt="" />
                )}
                {/* mark the placeholder state so it can be styled like an input placeholder (user 18-Oct-2026) */}
                <span className={userInput === props.placeholder ? "dd-ph" : ""}>{userInput}</span>
                {!props.isHideArrow || isFocus ? (
                  <div className="right-icon">
                    <ChevronDown id="img_downarrow" className="downarrow" />
                  </div>
                ) : (
                  ""
                )}
              </div>
              {isFocus && props.isDisable == false ? optionsListComponent : ""}
            </div>
          )}
        </div>
      </Fragment>
    </>
  );
};

CustomDropdown.defaultProps = {
  placeholder: "Select",
  selected: "",
  isSearchable: false,
  sakey: new Date().getTime(),
  type: "ARROW",
  isHideArrow: false,
  options: [],
  isDisable: false,
};

export default CustomDropdown;
